export enum Language {
  PL_ONLY = 'PL_ONLY',
  PL_EN = 'PL_EN',
  EN = 'EN',
  RU = 'RU'
}

export interface LanguageOption {
  code: Language;
  name: string;
  nativeName: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: Language.PL_ONLY, name: 'Polish Only', nativeName: 'Polski' },
  { code: Language.PL_EN, name: 'Polish-English', nativeName: 'Polski-English' },
  { code: Language.EN, name: 'English', nativeName: 'English' },
  { code: Language.RU, name: 'Russian', nativeName: 'Русский' }
];

// Языки, доступные для выбора пользователем в интерфейсе
export const USER_SELECTABLE_LANGUAGES: LanguageOption[] = [
  { code: Language.PL_ONLY, name: 'Polish Only', nativeName: 'Polski' },
  { code: Language.EN, name: 'English', nativeName: 'English' }
];

// Языки, доступные для выбора при создании/редактировании PDF фактур
// Включает польский, польско-английский и английский (без русского)
export const PDF_LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: Language.PL_ONLY, name: 'Polish Only', nativeName: 'Polski' },
  { code: Language.PL_EN, name: 'Polish-English', nativeName: 'Polski-English' },
  { code: Language.EN, name: 'English', nativeName: 'English' }
];

export const getLanguageName = (language: Language): string => {
  const option = LANGUAGE_OPTIONS.find(opt => opt.code === language);
  return option ? option.nativeName : language;
};

/**
 * Проверяет, является ли язык польским (включая двуязычный)
 */
export const isPolish = (language: Language): boolean => {
  return language === Language.PL_ONLY || language === Language.PL_EN;
};

/**
 * Проверяет, является ли язык чисто польским
 */
export const isPolishOnly = (language: Language): boolean => {
  return language === Language.PL_ONLY;
};

/**
 * Проверяет, является ли язык двуязычным польско-английским
 */
export const isPolishEnglish = (language: Language): boolean => {
  return language === Language.PL_EN;
};
